// import dynamicIndex from 'page/platform/dynamicDetail.vue'
// import videoPage from 'page/platform/videoPage.vue'
// import scenario from 'page/scenario'
// import scenarioList from 'page/scenarioList'
// import benefitAwardRule from 'page/benefitAwardRule'
const dynamicIndex = () =>
  import(
    /* webpackChunkName: "platform~dynamicIndex" */ 'page/platform/dynamicDetail.vue'
  )
const videoPage = () =>
  import(
    /* webpackChunkName: "platform~videoPage" */ 'page/platform/videoPage.vue'
  )
const scenario = () =>
  import(/* webpackChunkName: "platform~scenario" */ 'page/scenario')
const scenarioList = () =>
  import(/* webpackChunkName: "platform~scenarioList" */ 'page/scenarioList')
const benefitAwardRule = () =>
  import(
    /* webpackChunkName: "platform~benefitAwardRule" */ 'page/benefitAwardRule'
  )
const choicenessLesson = () =>
  import(
    /* webpackChunkName: "platform~choicenessLesson" */ 'page/choiceness/choicenessLesson'
  )
const platformVipCard = () =>
  import(
    /* webpackChunkName: "platform~platformVipCard" */ 'page/platform/platformVipCard'
  )
const platformVipMonthCard = () =>
  import(
    /* webpackChunkName: "platform~platformVipMonthCard" */ 'page/platform/platformVipMonthCard'
  )
// 创作比赛模板活动页面
const writingCompetition = () =>
  import(
    /* webpackChunkName: "platform~writingCompetition" */ 'page/platform/writingCompetition'
  )
// 创作比赛模板活动页面
const newGiftBag = () =>
  import(
    /* webpackChunkName: "platform~newGiftBag" */ 'page/platform/newGiftBag/index-v3.vue'
  )
// APP8.0版 动态详情
const newDynamicDetail = () =>
  import(
    /* webpackChunkName: "platform~newDynamicDetail" */ 'page/platform/newDynamicDetail'
  )
const topicDetail = () =>
  import(
    /* webpackChunkName: "platform~topicDetail" */ 'page/platform/topicDetail'
  )

// 聊天室-广场
const chatRoom = () =>
  import(/* webpackChunkName: "platform~chatRoom" */ 'page/platform/chatRoom')

// 聊天室-订单列表
const orderList = () =>
  import(
    /* webpackChunkName: "platform~orderList" */ 'page/platform/chatRoom/orderList'
  )

// 聊天室-预告
const advance = () =>
  import(
    /* webpackChunkName: "platform~advance" */ 'page/platform/chatRoom/advance'
  )

// 聊天室-聊天结束
const chatEnd = () =>
  import(
    /* webpackChunkName: "platform~chatEnd" */ 'page/platform/chatRoom/chatEnd'
  )

// 聊天室-分享落地页
const chatShare = () =>
  import(
    /* webpackChunkName: "platform~chatShare" */ 'page/platform/chatRoom/chatShare'
  )

// 聊天室-分享落地页
const chatPay = () =>
  import(
    /* webpackChunkName: "platform~chatPay" */ 'page/platform/chatRoom/chatPay'
  )

// 聊天室-问题页面
const chatQuestion = () =>
  import(
    /* webpackChunkName: "platform~chatQuestion" */ 'page/platform/chatRoom/chatQuestion'
  )

// 成为倾诉师引导页
const chatGuidance = () =>
  import(
    /* webpackChunkName: "platform~chatGuidance" */ 'page/platform/chatRoom/chatGuidance'
  )

// 公共协议页面
const protocol = () =>
  import(/* webpackChunkName: "platform~protocol" */ 'page/platform/protocol')

// 社群-社群主页
const communityIndex = () =>
  import(
    /* webpackChunkName: "platform~groupIndex" */ 'page/platform/appCommunity/index.vue'
  )

// 社群-群组分类
const classification = () =>
  import(
    /* webpackChunkName: "platform~groupIndex" */ 'page/platform/appCommunity/classification.vue'
  )

// app社群-群组主页
const groupIndex = () =>
  import(
    /* webpackChunkName: "platform~groupIndex" */ 'page/platform/appCommunity/groupIndex.vue'
  )

const professionalSupport = () =>
  import(
    /* webpackChunkName: "platform~professionalSupport" */ 'page/platform/appCommunity/professionalSupport.vue'
  )

const onlineCommunication = () =>
  import(
    /* webpackChunkName: "platform~onlineCommunication" */ 'page/platform/appCommunity/onlineCommunication.vue'
  )

// 群任务列表
const groupTaskList = () =>
  import(
    /* webpackChunkName: "platform~groupTask" */ 'page/platform/appCommunity/groupTaskList.vue'
  )

// // 群任务详情
// const groupTaskDetail = () =>
//   import(
//     /* webpackChunkName: "platform~groupTask" */ 'page/platform/appCommunity/groupTaskDetail.vue'
//   )

// 群组通知
const groupNotice = () =>
  import(
    /* webpackChunkName: "platform~groupTask" */ 'page/platform/appCommunity/groupNotice.vue'
  )
// 动态视频页面
const dynamicVideo = () =>
  import(
    /* webpackChunkName: "platform~dynamicVideo" */ 'page/platform/dynamicVideo'
  )

// 个人主页V2
const homepageV2 = () =>
  import(
    /* webpackChunkName: "platform~homepage~v2" */ 'page/platform/homepage/indexV2'
  )

// 新版个人主页ABtest
const homePageABtest = () =>
  import(
    /* webpackChunkName: "platform~homepage" */ 'page/platform/homepage/homePageABtest'
  )

const newDynamicVideo = () =>
  import(
    /* webpackChunkName: "platform~newDynamicVideo" */ 'page/platform/newDynamicVideo/index.vue'
  )

const topicSquare = () =>
  import(
    /* webpackChunkName: "platform~topicSquare" */ 'page/platform/topicSquare/index.vue'
  )

const groupPoster = () =>
  import(
    /* webpackChunkName: "platform~newDynamicVideo" */ 'page/platform/appCommunity/groupPoster.vue'
  )

const achievement = () =>
  import(
    /* webpackChunkName: "platform~newDynamicVideo" */ 'page/platform/appCommunity/achievement.vue'
  )

// 不常用群聊列表
const rarelyUsedGroup = () =>
  import(
    /* webpackChunkName: "platform~newDynamicVideo" */ 'page/platform/appCommunity/rarelyUsedGroup.vue'
  )

const inviteGroup = () =>
  import(
    /* webpackChunkName: "platform~InviteGroup" */ 'page/platform/appCommunity/InviteGroup.vue'
  )

const topicChoice = () =>
  import(
    /* webpackChunkName: "platform~topicChoice" */ 'page/platform/topicChoice/index.vue'
  )

const newUserTask = () =>
  import(
    /* webpackChunkName: "platform~newUserTask" */ 'page/platform/newUserTask/indexV2.vue'
  )

const newUserWelfare = () =>
  import(
    /* webpackChunkName: "platform~newUserWelfare" */ 'page/platform/newUserWelfare/index.vue'
  )

const weekFree = () =>
  import(
    /* webpackChunkName: "platform~weekFree" */ 'page/platform/weekFree/index.vue'
  )

const subjectList = () =>
  import(
    /* webpackChunkName: "platform~subjectList" */ 'page/platform/subject/subjectList.vue'
  )

const subjectDes = () =>
  import(
    /* webpackChunkName: "platform~subjectDes" */ 'page/platform/subject/subjectDes.vue'
  )

const upgradePkgsPage = () =>
  import(
    /* webpackChunkName: "platform~upgradePkgsPage" */ 'page/platform/upgradePkgsPage.vue'
  )

const signCalendar = () =>
  import(
    /* webpackChunkName: "platform~signCalendar" */ 'page/platform/signCalendar/index.vue'
  )

const questionier = () =>
  import(
    /* webpackChunkName: "platform~questionier" */ 'page/platform/questionier/index.vue'
  )

const dynamicVideoList = () =>
  import(
    /* webpackChunkName: "dynamic-videolist" */ 'page/platform/dynamicVideoList/index.vue'
  )

const oldUserBackflow = () =>
  import(
    /* webpackChunkName: "platform~oldUserBackflow" */ 'page/platform/oldUserBackflow.vue'
  )

import growthCenterRoutes from './growthCenter'
import mutualHelp from './mutualHelp'
import creatorCenter from './creatorCenter'
import groupActivity from './groupActivity'
import qa from './qa'
import encyclopedia from './encyclopedia'
import moodPractitioner from './moodPractitioner'
import bankRank from './bankRank'

let routes = [
  ...qa,
  ...creatorCenter,
  ...mutualHelp,
  ...growthCenterRoutes,
  ...groupActivity,
  ...encyclopedia,
  ...moodPractitioner,
  ...bankRank,
  {
    path: '/homepage/:userId',
    component: homepageV2,
    meta: {
      pageName: '个人主页',
      business: '平台',
      title: '个人主页'
    }
  },
  {
    path: '/homepageABtest',
    component: homePageABtest
  },
  {
    path: '/dynamic/:dynamicId',
    component: dynamicIndex,
    meta: {
      pageName: '动态详情',
      business: '动态',
      title: '动态详情'
    }
  },

  {
    path: '/video/:videoId',
    component: videoPage,
    meta: {
      pageName: '播放页',
      business: '短视频',
      title: '播放页'
    }
  },
  {
    path: '/scenario/:scenarioId',
    component: scenario,
    meta: {
      cache: 10 * 60 * 1000,
      business: '场景',
      pageName: '场景详情'
    }
  },
  {
    path: '/scenarioList/:id',
    component: scenarioList,
    meta: {
      cache: 10 * 60 * 1000,
      business: '场景'
    }
  },
  {
    path: '/benefitAwardRule',
    component: benefitAwardRule,
    meta: {
      cache: 10 * 60 * 1000
    }
  },
  {
    path: '/choicenessLesson',
    component: choicenessLesson,
    meta: {}
  },
  {
    path: '/platformVipCard',
    component: platformVipCard,
    meta: {
      pageName: '鲸选会员体验卡页',
      business: '鲸选会员',
      title: '壹心理'
    }
  },
  {
    path: '/platformVipMonthCard',
    component: platformVipMonthCard,
    meta: {
      pageName: '鲸选会员月卡页',
      business: '鲸选会员',
      title: '鲸选会员月卡'
    }
  },
  {
    path: '/writingCompetition',
    component: writingCompetition,
    meta: {
      pageName: '创作比赛',
      business: '创作比赛',
      title: '创作者提交页'
    }
  },
  {
    path: '/newGiftBag',
    component: newGiftBag,
    meta: {
      pageName: '新人礼活动页',
      business: '公共',
      title: '新人礼活动页',
      category: '新人礼活动'
    }
  },
  {
    path: '/dynamicDetail/:dynamicId',
    component: newDynamicDetail,
    meta: {
      pageName: '动态详情',
      business: '公共',
      title: '动态详情',
      category: '动态'
    }
  },
  {
    path: '/topicDetail/:topicId',
    component: topicDetail,
    meta: {
      pageName: '话题详情',
      business: '公共',
      title: '话题详情',
      category: '话题'
    }
  },
  {
    path: '/topicChoice',
    component: topicChoice,
    meta: {
      pageName: '话题选择',
      business: '公共',
      title: '话题选择',
      category: '话题'
    }
  },
  {
    path: '/chatRoom',
    component: chatRoom,
    meta: {
      pageName: '聊天室广场页',
      business: '聊天室',
      title: '聊天室',
      category: '聊天室'
    }
  },
  {
    path: '/chatRoom/orderList',
    component: orderList,
    meta: {
      pageName: '我的订单',
      business: '聊天室',
      title: '我的订单',
      category: '聊天室'
    }
  },
  {
    path: '/chatRoom/advance/:chatRoomId',
    component: advance,
    meta: {
      pageName: '闲聊唠叨',
      business: '聊天室',
      title: '聊天室',
      category: '聊天室'
    }
  },
  {
    path: '/chatRoom/chatEnd',
    component: chatEnd,
    meta: {
      pageName: '聊天结束页',
      business: '聊天室',
      title: '聊天室',
      category: '聊天室'
    }
  },
  {
    path: '/chatRoom/chatShare/:chatRoomId',
    component: chatShare,
    meta: {
      pageName: '聊天室分享落地页',
      business: '聊天室',
      title: '聊天室',
      category: '聊天室'
    }
  },
  {
    path: '/chatRoom/chatPay/:chatRoomId',
    component: chatPay,
    meta: {
      pageName: '聊天室支付页',
      business: '聊天室',
      title: '聊天室',
      category: '聊天室'
    }
  },
  {
    path: '/chatRoom/chatQuestion',
    component: chatQuestion,
    meta: {
      pageName: '聊天室',
      business: '聊天室',
      title: '如何创建房间',
      category: '聊天室'
    }
  },
  {
    path: '/chatRoom/chatGuidance',
    component: chatGuidance,
    meta: {
      pageName: '聊天室',
      business: '聊天室',
      title: '成为倾诉师',
      category: '聊天室'
    }
  },
  {
    path: '/protocol',
    component: protocol,
    meta: {
      pageName: '聊天室',
      business: '聊天室',
      title: '成为倾诉师',
      category: '聊天室'
    }
  },
  {
    path: '/appCommunity/index',
    component: communityIndex,
    meta: {
      pageName: '社群主页',
      business: '平台',
      title: '社群'
    }
  },
  {
    path: '/appCommunity/classification',
    component: classification,
    meta: {
      pageName: '群组分类',
      business: '平台',
      title: '群组分类'
    }
  },
  {
    path: '/appCommunity/groupIndex/:groupId',
    component: groupIndex,
    meta: {
      pageName: '群组主页',
      business: '平台',
      title: '群组主页'
    }
  },
  {
    path: '/appCommunity/professionalSupport',
    component: professionalSupport,
    meta: {
      pageName: '专业支持',
      business: '平台',
      title: '专业支持'
    }
  },
  {
    path: '/appCommunity/onlineCommunication',
    component: onlineCommunication,
    meta: {
      pageName: '在线交流',
      business: '平台',
      title: '在线交流'
    }
  },

  {
    path: '/appCommunity/groupTaskList/:groupId',
    name: 'groupTaskList',
    component: groupTaskList,
    meta: {
      pageName: '群任务列表',
      business: '平台',
      title: '群任务列表'
    }
  },
  // {
  //   path: '/appCommunity/groupTaskDetail/:taskId',
  //   name: 'groupTaskDetail',
  //   component: groupTaskDetail,
  //   meta: {
  //     pageName: '群任务详情',
  //     business: '平台',
  //     title: '群任务详情'
  //   }
  // },
  {
    path: '/appCommunity/groupNotice',
    name: 'groupNotice',
    component: groupNotice,
    meta: {
      pageName: '群组通知',
      business: '平台',
      title: '群组通知'
    }
  },
  {
    path: '/dynamicVideo/:videoId',
    component: dynamicVideo,
    meta: {
      pageName: '动态视频',
      business: '动态视频',
      title: '动态视频',
      category: '首页'
    }
  },

  {
    path: '/newDynamicVideo/:dynamicId',
    component: newDynamicVideo,
    meta: {
      pageName: '动态视频',
      business: '平台',
      title: '动态视频'
    }
  },

  {
    path: '/topicSquare',
    component: topicSquare,
    meta: {
      pageName: '话题广场',
      business: '平台',
      title: '话题广场'
    }
  },

  {
    path: '/appCommunity/groupPoster/:groupId',
    component: groupPoster,
    meta: {
      pageName: '群组-赠好友',
      business: '平台',
      title: '赠好友'
    }
  },
  {
    path: '/appCommunity/achievement',
    component: achievement,
    meta: {
      pageName: '群组-赠好友',
      business: '平台',
      title: '赠好友'
    }
  },
  {
    path: '/appCommunity/rarelyUsedGroup',
    component: rarelyUsedGroup,
    meta: {
      pageName: '不常用群聊列表',
      business: '平台',
      title: '不常用群聊列表'
    }
  },
  {
    path: '/appCommunity/inviteGroup',
    component: inviteGroup,
    meta: {
      pageName: '群聊邀请',
      business: '平台',
      title: '群聊邀请'
    }
  },
  {
    path: '/newUserTask',
    component: newUserTask,
    meta: {
      pageName: '新手任务',
      business: '平台',
      title: '新手任务'
    }
  },
  {
    path: '/newUserWelfare',
    component: newUserWelfare,
    meta: {
      pageName: '新人限时福利',
      business: '平台',
      title: '新人限时福利'
    }
  },
  {
    path: '/weekFree',
    component: weekFree,
    meta: {
      pageName: '周周领福利',
      business: '平台',
      title: '周周领福利'
    }
  },
  {
    path: '/subjectList',
    component: subjectList,
    meta: {
      pageName: '合集页',
      business: '平台',
      title: '阅读专栏'
    }
  },
  {
    path: '/subjectDes/:id',
    component: subjectDes,
    meta: {
      pageName: '阅读详情',
      business: '平台',
      title: '阅读详情'
    }
  },
  {
    path: '/consult/upgradePkgsPage',
    component: upgradePkgsPage,
    meta: {
      business: '咨询'
    }
  },
  {
    path: '/sign/calendar',
    component: signCalendar,
    meta: {
      pageName: '我的签到日历',
      business: '平台',
      title: '我的签到日历'
    }
  },
  {
    path: '/task/questionier',
    component: questionier,
    meta: {
      pageName: '问题收集',
      business: '平台',
      title: '问题收集'
    }
  },
  {
    path: '/dynamic-videolist',
    component: dynamicVideoList,
    meta: {
      pageName: '热门视频',
      business: '平台',
      title: '热门视频'
    }
  },
  {
    path: '/olduser-backflow',
    component: oldUserBackflow,
    meta: {
      pageName: '老用户转化专区',
      business: '平台',
      title: '老用户转化专区'
    }
  }
]

export default routes
